import script from "./WelcomeModal.vue?vue&type=script&setup=true&lang=js"
export * from "./WelcomeModal.vue?vue&type=script&setup=true&lang=js"

import "./WelcomeModal.vue?vue&type=style&index=0&id=87143cac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-87143cac"]])

export default __exports__